import React from 'react';

const Icon = () => (
  <svg
    width="66"
    height="20"
    viewBox="0 0 66 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <rect width="66" height="20" rx="2" fill="#FFEEED" />
    <path
      d="M25.94 9.11H28.85V10.02H25.94V9.11ZM25.49 9.11H26.43V13.38C26.43 13.78 26.5 13.84 26.93 13.84C27.13 13.84 28.05 13.84 28.3 13.84C28.72 13.84 28.79 13.59 28.84 12.2C29.05 12.36 29.45 12.53 29.71 12.59C29.6 14.25 29.34 14.73 28.37 14.73C28.15 14.73 27.02 14.73 26.81 14.73C25.81 14.73 25.49 14.45 25.49 13.38V9.11ZM25.46 6.02H29.32V10.68H28.41V6.93H25.46V6.02ZM20.72 7.79H24.81V14.66H24.05V8.58H21.47V14.8H20.72V7.79ZM21.11 11.82H24.41V12.5H21.11V11.82ZM21.11 13.39H24.41V14.14H21.11V13.39ZM20.5 5.94H25.02V6.78H20.5V5.94ZM21.9 6.15H22.55V8.39H21.9V6.15ZM23.05 6.15H23.71V8.39H23.05V6.15ZM22.04 8.38H22.52V9.38C22.52 9.98 22.39 10.75 21.84 11.3C21.76 11.2 21.57 11.03 21.46 10.97C21.97 10.49 22.04 9.88 22.04 9.37V8.38ZM22.98 8.38H23.47V10.35C23.47 10.48 23.48 10.5 23.58 10.5C23.62 10.5 23.81 10.5 23.86 10.5C23.96 10.5 23.99 10.49 24 10.47C24.11 10.56 24.3 10.62 24.45 10.66C24.39 10.9 24.24 11 23.95 11C23.87 11 23.6 11 23.52 11C23.11 11 22.98 10.89 22.98 10.36V8.38ZM34.27 6H38.89V6.76H34.27V6ZM34.14 8.82H39.07V9.58H34.14V8.82ZM34.14 10.23H39.04V10.99H34.14V10.23ZM34.51 13.64H38.69V14.41H34.51V13.64ZM33.33 7.4H39.81V8.18H33.33V7.4ZM34.01 11.64H39.18V14.81H38.23V12.39H34.92V14.84H34.01V11.64ZM32.82 5.59L33.7 5.87C33.02 7.56 31.94 9.29 30.82 10.41C30.73 10.19 30.47 9.68 30.31 9.46C31.29 8.53 32.25 7.07 32.82 5.59ZM31.81 8.25L32.7 7.35L32.71 7.36V14.82H31.81V8.25ZM43.49 6.5H49.88V7.31H43.49V6.5ZM46.16 5.59H47.11V6.88H46.16V5.59ZM45.11 8.43V9.19H48.21V8.43H45.11ZM44.21 7.78H49.16V9.84H44.21V7.78ZM43.29 10.33H49.99V12.14H49.12V11.07H44.13V12.15H43.29V10.33ZM44.54 11.63H48.79V12.4H44.54V11.63ZM46.16 11.81H47.1V13.88C47.1 14.36 47.01 14.6 46.65 14.73C46.28 14.86 45.75 14.86 44.99 14.86C44.96 14.6 44.83 14.25 44.72 14C45.25 14.02 45.81 14.02 45.96 14.01C46.12 14.01 46.16 13.97 46.16 13.86V11.81ZM42.82 5.6L43.71 5.88C43.06 7.58 42.03 9.32 40.94 10.45C40.85 10.22 40.59 9.71 40.42 9.49C41.38 8.55 42.28 7.08 42.82 5.6ZM41.82 8.26L42.71 7.36L42.72 7.37V14.83H41.82V8.26ZM55.82 8.82H59.49V9.77H55.82V8.82ZM50.9 13.4H59.98V14.34H50.9V13.4ZM55.34 5.58H56.34V13.89H55.34V5.58ZM52.24 7.71H53.22V13.85H52.24V7.71Z"
      fill="#EB5757"
    />
    <path
      d="M10.5 13.5H7C6.7 13.5 6.5 13.3 6.5 13V7C6.5 6.7 6.7 6.5 7 6.5H15C15.3 6.5 15.5 6.7 15.5 7V9.45"
      stroke="#EB5757"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M15 6.75L11 10L7 6.75"
      stroke="#EB5757"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14 14.7C15.1 14.7 16 13.8 16 12.7C16 11.6 15.1 10.7 14 10.7C12.9 10.7 12 11.6 12 12.7C12 13.8 12.85 14.7 14 14.7Z"
      stroke="#EB5757"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.55 14.1L15.4 11.3"
      stroke="#EB5757"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default Icon;
